import React from 'react';
import { FormattedMessage } from '../../../util/reactIntl';
import YourChoiceIcon from "./icons/YourChoiceIcon";
import FlexibilityIcon from "./icons/FlexibilityIcon";
import PostJobFreeIcon from "./icons/PostJobFreeIcon";
import NoAdditionalFeesIcon from "./icons/NoAdditionalFeesIcon";
import ExtraSupportIcon from "./icons/ExtraSupportIcon";
import PriceIcon from "./icons/PriceIcon";

import { ExternalLink, NamedLink } from "../../../components";
import classNames from "classnames";

import css from './SectionWhyHireOnlineTeachersWithAllCourse.module.css';
import { getBullets } from '../../../util/contentful';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';

const SectionWhyHireOnlineTeachersWithAllCourse = props => {
  const { subject, state, content } = props;

  const items = content && getBullets(content, 'whyBullet');


  return (
    <div className={css.root}>
      <div className={css.rootTitleHolder}>
        <h2 className={css.rootTitle}>
          {content?.whyTitle ?
            content.whyTitle :
            <FormattedMessage
              values={{ state: state?.label || '', subject: subject?.parent || '' }}
              id='SectionWhyHireOnlineTeachersWithAllCourse.title'
            />
          }
        </h2>
      </div>

      <p className={css.rootDescription}>
        {content?.whyDescription ?
          content.whyDescription :
          state && !subject ?
          <FormattedMessage id="SectionWhyHireOnlineTeachersWithAllCourse.stateDescription" values={{state: state.label}} /> :
            state && subject ?
          <FormattedMessage id="SectionWhyHireOnlineTeachersWithAllCourse.subjectDescription" values={{state: state.label, subject: subject.parent}} /> :
          <FormattedMessage id="SectionWhyHireOnlineTeachersWithAllCourse.description" />
        }
      </p>

      <div className={css.teachersInfo}>
        {content && items ? Array.from(Array(Object.keys(items).length / 3).keys()).map(i => (
          <div className={classNames(css.teachersInfoItem, css.teachersInfoItem1)}>
            <img src={`https:${items[`whyBullet${i + 1}Icon`].fields?.file?.url}`} className={css.image} />
            <div className={css.teachersInfoItemContent}>
              <h3 className={css.teachersInfoItemTitle}>
                {items[`whyBullet${i + 1}Title`]}
              </h3>
              <p className={css.teachersInfoItemDescription}>
                {documentToReactComponents(items[`whyBullet${i + 1}Description`])}
              </p>
            </div>
          </div>
        )) : <>
          <div className={classNames(css.teachersInfoItem, css.teachersInfoItem1)}>
            <YourChoiceIcon />
            <div className={css.teachersInfoItemContent}>
              <h3 className={css.teachersInfoItemTitle}>
                <FormattedMessage id="SectionWhyHireOnlineTeachersWithAllCourse.itemTitle1" />
              </h3>
              <p className={css.teachersInfoItemDescription}>
                {state && !subject ?
                  <FormattedMessage
                    id='SectionWhyHireOnlineTeachersWithAllCourse.itemStateDescription1'
                    values={{ state: state?.label }} /> :
                  state && subject ?
                    <FormattedMessage
                      id='SectionWhyHireOnlineTeachersWithAllCourse.itemSubjectDescription1'
                      values={{ state: state?.label, subject: subject?.parent }} /> :
                    <FormattedMessage id='SectionWhyHireOnlineTeachersWithAllCourse.itemDescription1' />
                }
              </p>
            </div>
          </div>

          <div className={classNames(css.teachersInfoItem, css.teachersInfoItem2)}>
            <FlexibilityIcon />
            <div className={css.teachersInfoItemContent}>
              <h3 className={css.teachersInfoItemTitle}>
                <FormattedMessage id="SectionWhyHireOnlineTeachersWithAllCourse.itemTitle2" />
              </h3>
              <p className={css.teachersInfoItemDescription}>
                {state && !subject ?
                  <FormattedMessage
                    id='SectionWhyHireOnlineTeachersWithAllCourse.itemStateDescription2'
                    values={{ state: state?.label }} /> :
                  state && subject ?
                    <FormattedMessage
                      id='SectionWhyHireOnlineTeachersWithAllCourse.itemSubjectDescription2'
                      values={{ state: state?.label, subject: subject?.parent }} /> :
                    <FormattedMessage id='SectionWhyHireOnlineTeachersWithAllCourse.itemDescription2' />
                }
              </p>
            </div>
          </div>

          <div className={classNames(css.teachersInfoItem, css.teachersInfoItem3)}>
            <PriceIcon />
            <div className={css.teachersInfoItemContent}>
              <h3 className={css.teachersInfoItemTitle}>
                <FormattedMessage id="SectionWhyHireOnlineTeachersWithAllCourse.itemTitle3" />
              </h3>
              <p className={css.teachersInfoItemDescription}>
                {state && !subject ?
                  <FormattedMessage
                    id='SectionWhyHireOnlineTeachersWithAllCourse.itemStateDescription3'
                    values={{ state: state?.label }} /> :
                  state && subject ?
                    <FormattedMessage
                      id='SectionWhyHireOnlineTeachersWithAllCourse.itemSubjectDescription3'
                      values={{ state: state?.label, subject: subject?.parent }} /> :
                    <FormattedMessage id='SectionWhyHireOnlineTeachersWithAllCourse.itemDescription3' />
                }
              </p>
            </div>
          </div>

          <div className={classNames(css.teachersInfoItem, css.teachersInfoItem4)}>
            <PostJobFreeIcon />
            <div className={css.teachersInfoItemContent}>
              <h3 className={css.teachersInfoItemTitle}>
                <FormattedMessage id="SectionWhyHireOnlineTeachersWithAllCourse.itemTitle4" />
              </h3>
              <p className={css.teachersInfoItemDescription}>
                {state && !subject ?
                  <FormattedMessage
                    id='SectionWhyHireOnlineTeachersWithAllCourse.itemStateDescription4'
                    values={{ state: state?.label }} /> :
                  state && subject ?
                    <FormattedMessage
                      id='SectionWhyHireOnlineTeachersWithAllCourse.itemSubjectDescription4'
                      values={{ state: state?.label, subject: subject?.parent }} /> :
                    <FormattedMessage id='SectionWhyHireOnlineTeachersWithAllCourse.itemDescription4' />
                }
              </p>
            </div>
          </div>

          <div className={classNames(css.teachersInfoItem, css.teachersInfoItem5)}>
            <NoAdditionalFeesIcon />
            <div className={css.teachersInfoItemContent}>
              <h3 className={css.teachersInfoItemTitle}>
                <FormattedMessage id="SectionWhyHireOnlineTeachersWithAllCourse.itemTitle5" />
              </h3>
              <p className={css.teachersInfoItemDescription}>
                {state && !subject ?
                  <FormattedMessage
                    id='SectionWhyHireOnlineTeachersWithAllCourse.itemStateDescription5'
                    values={{ state: state?.label }} /> :
                  state && subject ?
                    <FormattedMessage
                      id='SectionWhyHireOnlineTeachersWithAllCourse.itemSubjectDescription5'
                      values={{ state: state?.label, subject: subject?.parent }} /> :
                    <FormattedMessage
                      id="SectionWhyHireOnlineTeachersWithAllCourse.itemDescription5"
                      values={{
                        referralLink: (
                          <NamedLink name="ReferralPage" className={css.link}>
                            <FormattedMessage id="SectionTeachingWithAllCourse.seeDetails" />
                          </NamedLink>
                        )
                      }}
                    />
                }

              </p>
            </div>
          </div>

          <div className={classNames(css.teachersInfoItem, css.teachersInfoItem6)}>
            <ExtraSupportIcon />
            <div className={css.teachersInfoItemContent}>
              <h3 className={css.teachersInfoItemTitle}>
                <FormattedMessage id="SectionWhyHireOnlineTeachersWithAllCourse.itemTitle6" />
              </h3>
              <p className={css.teachersInfoItemDescription}>
                {state && !subject ?
                  <FormattedMessage
                    id='SectionWhyHireOnlineTeachersWithAllCourse.itemStateDescription6'
                    values={{ state: state?.label }} /> :
                  state && subject ?
                    <FormattedMessage
                      id='SectionWhyHireOnlineTeachersWithAllCourse.itemSubjectDescription6'
                      values={{ state: state?.label, subject: subject?.parent }} /> :
                    <FormattedMessage
                      id="SectionWhyHireOnlineTeachersWithAllCourse.itemDescription6"
                      values={{
                        freeLearningLink: (
                          <ExternalLink href="https://home.allcourse.com/" className={css.link}>
                            <FormattedMessage id="SectionTeachingWithAllCourse.freeLearning" />
                          </ExternalLink>
                        )
                      }}
                    />
                }

              </p>
            </div>
          </div>
        </>}
      </div>
    </div>
  );
};

export default SectionWhyHireOnlineTeachersWithAllCourse;
